<template>
  <div>
    <b-card class="mt-5">
      <b-form v-on:submit.prevent="updateUser" data-vv-scope="profile">
        <h3>Il mio Profilo</h3>
        <!-- user detail -->

        <b-alert show variant="info" v-if="!isProfileConfirmed">
          Per accedere alle altre sezioni, è necessario confermare i propri dati di profilo e modificare la password di accesso.
        </b-alert>

        <b-row>
          <b-col>
            <b-form-group
              label="Cognome" :class="{'has-danger': errors.has('last_name') }">
              <b-form-input
                v-validate data-vv-rules="alpha_spaces|required" data-vv-as="Cognome" name="last_name"
                type="text" v-model="user.last_name" required
                placeholder="Cognome"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Nome" :class="{'has-danger': errors.has('first_name') }">
              <b-form-input
                v-validate data-vv-rules="alpha_spaces|required" data-vv-as="Nome"
                name="first_name"
                type="text" v-model="user.first_name"
                placeholder="Nome"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Email" :class="{'has-danger': errors.has('email') }"
              description="La tua mail">
              <b-form-input
                v-validate data-vv-rules="email|required|user_unique_email" data-vv-as="Email"
                type="email" name="email" data-vv-validate-on="change" v-model="user.email"
                placeholder="La tua mail"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Numero Cellulare" :class="{'has-danger': errors.has('phone_number') }"
              description="Il tuo numero principale, che puoi usare come login alternativo">
              <b-form-input
                v-validate data-vv-rules="phone_number|user_unique_phone_number" data-vv-delay="500"
                data-vv-as="Cellulare" name="phone_number"
                data-vv-validate-on="change" type="tel" v-model="user.phone_number"
                :formatter="phoneNumberFormatter" lazy-formatter
                placeholder="Il tuo numero"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-5" v-if="user.users_group">
          <b-col cols="6">
            <p>Gruppo di appartenza<br>
              <strong>{{ user.users_group.name }}</strong>
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-5">
          <b-col>
            <button class="btn btn-primary" v-on:click="updateUser()" :disabled="errors.any()">
              <strong>Aggiorna dettagli</strong>
            </button>
            <button class="btn btn-default" v-on:click="resetProfile()">
              Annulla
            </button>
          </b-col>
        </b-row>
      </b-form>
      <hr>


      <b-form v-on:submit.prevent="updateUser" data-vv-scope="password">
        <h5 class="mt-3">Aggiorna password</h5>
        <b-row>
          <b-col>
            <b-form-group
              label="Password" :class="{'has-danger': errors.has('password') }">
              <b-form-input
                v-validate data-vv-rules="required|min:8|verify_password"
                data-vv-as="Password" name="password"
                type="password" v-model="pass.password" required
                placeholder="password"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Conferma password" :class="{'has-danger': errors.has('password_confirm') }">
              <b-form-input
                v-validate data-vv-rules="required|confirmed:password" data-vv-as="Conferma password" name="password_confirm"
                type="password" v-model="pass.password_confirm" required
                placeholder="Conferma password"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <button class="btn btn-danger" v-on:click="updatePassword()" :disabled="errors.any()">
              <strong>Aggiorna password</strong>
            </button>
            <button class="btn btn-default" v-on:click="resetPassword()">
              Annulla
            </button>
          </b-col>
        </b-row>
      </b-form>

      <hr v-if="errors.any()">
      <div v-for="error in errors.all()">
        <b-alert show variant="danger">
          {{ error }}
        </b-alert>
      </div>
    </b-card>


    <b-card title="Piani Sottoscritti" class="mt-5">
      <b-table striped hover :items="plans" :fields="plansFields"></b-table>
    </b-card>

    <b-card title="Dispositivi" class="mt-5">
      <p v-if="!devices.length" class="text-center p3">
        Non hai ancora installato l'app Skillo? Cosa aspetti, <a href="https://www.skillo.it/it/scarica-app">clicca qui
        per scaricare</a> quella più giusta per la tua piattaforma.
      </p>
      <b-table striped hover :items="devices"
               :fields="devicesFields" v-else></b-table>
    </b-card>
  </div>
</template>

<script>
  import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';

  const PNF = require('google-libphonenumber').PhoneNumberFormat;
  const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
  import { UPDATE_USER }  from '@/store/mutationTypes';


  export default {
    name: 'Profilo',
    data: () => ({
      plansFields: [
        {
          key: 'code',
          label: 'Piano',
          sortable: true,
          formatter: (value, key, row) => `${row.plan.code}: ${row.plan.name || row.plan.description || '-'}`,
        },
        {
          key: 'devices_max',
          label: 'Dispositivi inclusi',
          sortable: true,
          formatter: (value, key, row) => {
            if (row.plan.devices_max === 9999) return 'Illimitati';
            else if (row.plan.devices_max < 0) return 'N/A';
            return row.plan.devices_max;
          },
        },
        {
          key: 'ticket_per_cycle',
          label: 'Interventi inclusi',
          sortable: true,
          formatter: (value, key, row) => `${(row.ticket_per_cycle === 9999 || row.ticket_per_cycle === -1) ? 'Illimitati' : row.ticket_per_cycle}`,
        },
        { key: 'status', label: 'Stato', sortable: true },
        {
          key: 'date_start',
          label: 'Attivazione',
          sortable: true,
          formatter: (value, key, row) => (value ? moment(value).format('DD/MM/YYYY') : '-'),
        },
        {
          key: 'date_expiration',
          label: 'Scadenza',
          sortable: true,
          formatter: (value, key, row) => (value ? moment(value).format('DD/MM/YYYY') : '-'),
        },
      ],
      devicesFields: [
        { key: 'type', label: 'Tipo', sortable: true },
        { key: 'device_name', label: 'Dispositivo', sortable: true },
        { key: 'phone_number', label: 'Numero di telefono', sortable: true },
        {
          key: 'last_access_time',
          label: 'Ultimo accesso',
          sortable: true,
          formatter: (value, key, row) => (value ? moment(value).format('DD/MM/YYYY') : '-'),
        },
        {
          key: 'created_at',
          label: 'Primo accesso',
          sortable: true,
          formatter: (value, key, row) => (value ? moment(value).format('DD/MM/YYYY') : '-'),
        },
      ],
      pass: {
        password: null,
        confirm: null,
      },
    }),

    computed: {
      ...mapState({
        user: state => state.user,
        plans: state => state.plans,
        devices: state => state.devices,
      }),
      ...mapGetters([
        'isAdmin',
        'isProfileConfirmed'
      ])
    },

    mounted() {
      this.getData();
    },

    methods: {
      ...mapActions([
        'getProfile',
        'getDevices',
        'getPlans',
        'getTickets',
      ]),

      ...mapMutations({
        saveUserData: UPDATE_USER // map `this.add()` to `this.$store.commit('increment')`
      }),

      async getData() {
        const loader = this.$loading.show();
        try {
          await Promise.all([
            this.getProfile(),
            this.getDevices(),
            this.getPlans(),
            this.getTickets(),
          ]);

          loader.hide();
        } catch (err) {
          loader.hide();
          this.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');
        }
      },

      phoneNumberFormatter(value, event) {
        const phoneNumber = phoneUtil.parse(value, 'IT');
        const formatted = phoneUtil.format(phoneNumber, PNF.E164);
        return formatted;
      },

      async updateUser() {
        await this.$validator.validateAll('profile');

        if (this.errors.any()) {
          return;
        }

        try {
          const data = await this.$apiclient.updateProfile({
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            email: this.user.email,
            phone_number: this.user.phone_number,
          });

          this.saveUserData(data, null);
        } catch (err) {
          console.log(err);
          this.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');
        }
      },

      async updatePassword() {
        await this.$validator.validateAll('password');

        if (this.errors.any()) {
          return;
        }

        try {
          this.user = await
          this.$apiclient.updateProfile(this.pass);
          this.$toastr.info('Password aggiornata con successo');
        } catch (err) {
          console.log(err);
          this.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');
        }
      },

      resetPassword() {
        this.pass.password = null;
        this.pass.password_confirm = null;
        this.$validator.reset('password');
      },
      resetProfile() {
        this.getProfile();
        this.$validator.reset('profile');
      },
    },
  };

</script>

<style scoped>
  .card {
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/pages/AreaRiservata/Profilo.vue